module.exports = __webpack_public_path__ + "static/media/study 211104.00573c25.png";